import React from 'react';

import { TypographyLink, TypographyLinkProps } from '@explorer/core';
import { formatMessage } from '@explorer/helpers';
import { useIntl } from 'react-intl';

import { CellEmpty } from '../CellEmpty';

/**
 * CellLink
 */
export const CellLink = ({
  text,
  href,
  title,
  variant = 'bodyXS',
  textColor = undefined,
  monospace = false,
  linkIcon = 'external',
}: CellLinkProps) => {
  const intl = useIntl();

  if (!text || !href) return <CellEmpty variant={variant} />;

  const formattedText = formatMessage(intl, text);

  return (
    <TypographyLink
      href={href}
      title={title}
      variant={variant}
      monospace={monospace}
      textColor={textColor}
      linkIcon={linkIcon}
      onClick={(e: any) => e.stopPropagation()}
      newTab
    >
      {formattedText}
    </TypographyLink>
  );
};

/**
 * CellLink Props
 */
export interface CellLinkProps
  extends Pick<
    TypographyLinkProps,
    'href' | 'title' | 'variant' | 'monospace' | 'textColor' | 'linkIcon'
  > {
  text: IntlLabel;
}
